import { useEffect } from 'react';
import { FormikProps } from 'formik';
import { useRouterHelper, useTranslation } from '@shared/core';
import { useContactCollectorGuestTelemetryTelemetry } from '../../ContactCollectorGuest.telemetry';
import { contactCollectorGuestRoutePaths } from '../..';
import { Contacts } from '../../ContactCollectorGuest.controller';

export const useConfirmationController = (formik: FormikProps<Contacts>) => {
  const { buttonInteracted } = useContactCollectorGuestTelemetryTelemetry();
  const routeHelpers = useRouterHelper();
  const { t } = useTranslation('contactCollector');
  const tAdmin = t('admin');

  useEffect(() => {
    if (!formik.isValid) {
      return routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.landing.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnModifyDetailsClick = () => {
    buttonInteracted({ label: 'ModifyDetails' });
    routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.form.path);
  };

  const handleOnLooksGoodClick = () => {
    buttonInteracted({ label: 'LooksGood' });
    formik.handleSubmit();
  };

  return {
    tAdmin,
    handleOnModifyDetailsClick,
    handleOnLooksGoodClick,
  };
};
